import { render, staticRenderFns } from "./video-item.vue?vue&type=template&id=263444c3"
import script from "./video-item.vue?vue&type=script&lang=js"
export * from "./video-item.vue?vue&type=script&lang=js"
import style0 from "./video-item.vue?vue&type=style&index=0&id=263444c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports